import events from 'events';

const EE = new events.EventEmitter();

export default EE